module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-06.7c3ea2da.jpg";